import React, {useRef, useEffect, Fragment} from 'react';
import {Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';

const useStyles=makeStyles(theme=>({
  input:{
    display:'none',
    width:(props)=>(props.no_margin==true)?'100%':'calc(100% - 40px)',
    borderRadius:'5px',
    borderWidth:'0px',
    marginLeft:(props)=>(props.no_margin==true)?'0px':'20px',
    marginRight:(props)=>(props.no_margin==true)?'0px':'20px',
    backgroundColor:theme.palette.primary.main
  }
}))

export default function Colour_input(props){
  const classes=useStyles(props);
  let inputRef=useRef();


  return(
    <Fragment>
    <div style={{borderStyle:'solid', borderWidth:'0.5px', borderColor:'black',  width:'calc(100% - 20px)', marginLeft:'10px'}}>
      <label onClick={()=>{inputRef.current.click();}}>
        <div style={{cursor:'pointer', position:'relative', borderStyle:'solid', borderColor:(props.value=='')?'white':props.value, backgroundColor:'transparent', borderWidth:'2px', borderLeftWidth:'20px', borderRightWidth:'20px', height:'30px'}}>
          <div style={{position:'absolute', top:'0', left:'10px', display:'flex', justifyContent:'center', alignItems:'center', width:'calc(100% - 20px)', height:'30px', lineHeight:'30px'}}><Typography color='secondary'>{props.title}</Typography></div>
        </div>
      </label>
    </div>
    <input ref={inputRef} style={{visibility:'hidden', position:'absolute', zIndex:-1}} name={props.name} id={props.name} value={props.value} onChange={props.onChange} type='color'/>
    </Fragment>
  )
}
